import { useTranslation } from "react-i18next";
import TelegramFirst from "../../../../assets/images/TelegramFirstStep.svg";
import TelegramFirst1 from "../../../../assets/images/TelegramFirstStep1.svg";
import TelegramSecond from "../../../../assets/images/TelegramSecondStep.svg";
import TelegramThird from "../../../../assets/images/TelegramThirdStep.svg";
import TelegramThird1 from "../../../../assets/images/TelegramThirdStep1.svg";
import styles from "./AddTelegramModal.module.scss";

export const useStepContent = () => {
  const { t } = useTranslation();

  return [
    [
      {
        text: (
          <>
            {t("telegram.step1.part1")}{" "}
            <span className={styles.bold}>@Botfather</span>{" "}
            {t("telegram.step1.part2")}
            <span className={styles.bold}>{t("telegram.step1.part3")}</span>
          </>
        ),
        image: TelegramFirst,
      },
      {
        text: t("telegram.step1.part4"),
        image: TelegramFirst1,
      },
    ],
    [
      {
        text: (
          <>
            {t("telegram.step2.part1")}{" "}
            <span className={styles.bold}>/newbot</span>{" "}
            {t("telegram.step2.part2")}
          </>
        ),
        image: TelegramSecond,
      },
    ],
    [
      {
        text: (
          <>
            {t("telegram.step3.part1")} t.me/{"<bot_username>"}{" "}
            {t("telegram.step3.part2")}
          </>
        ),
        image: TelegramThird,
      },
      {
        text: <>{t("telegram.step3.part3")}</>,
        image: TelegramThird1,
      },
    ],
  ];
};
